import { useMemo } from "react";

type BrowserName =
  | "Edge"
  | "SecondLife"
  | "Opera"
  | "Chrome"
  | "Safari"
  | "Firefox"
  | "Internet Explorer"
  | "Unknown";

function detectBrowser(): BrowserName {
  const userAgent =
    typeof window !== "undefined" ? window.navigator.userAgent : "";

  if (/Edg\//.test(userAgent)) {
    return "Edge";
  } else if (/SecondLife\//.test(userAgent)) {
    return "SecondLife";
  } else if (/OPR\//.test(userAgent) || /Opera/.test(userAgent)) {
    return "Opera";
  } else if (/Chrome\//.test(userAgent)) {
    return "Chrome";
  } else if (/Safari\//.test(userAgent) && !/Chrome\//.test(userAgent)) {
    return "Safari";
  } else if (/Firefox\//.test(userAgent)) {
    return "Firefox";
  } else if (/MSIE|Trident\//.test(userAgent)) {
    return "Internet Explorer";
  } else {
    return "Unknown";
  }
}

export function useBrowserName(): BrowserName {
  return useMemo(() => detectBrowser(), []);
}
